import RouteState from "./route"
import router from "@/router";
import {login, getInfo} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {decrypt_token, encryption_token, decryption_info} from "@/utils/encryption";
// import {resetRouter} from '@/router'

// import da from "element-ui/src/locale/lang/da";

const getDefaultState = () => {
    return {
        token: getToken(),
        UserInfo: '',
        route: RouteState.state.WhiteRoute,
        redi: false
    }
}


const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {

        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {

        if (getToken()) {
            state.route = state.route.concat(RouteState.state.LoginRoute)
            router.addRoutes(state.route)
        } else {
            let old_token = decrypt_token(token) ? decrypt_token(token) : ''
            let new_token = encryption_token(old_token) ? encryption_token(old_token) : ''
            setToken(new_token)
            state.token = new_token
            state.route = state.route.concat(RouteState.state.LoginRoute)
            router.addRoutes(state.route)
        }


    },
    SET_INFO: (state, info) => {
        state.UserInfo = info
        // state.route=[]


    },
    GET_ROUTE: (state, data) => {
        state.redi = data
    },


}

const actions = {
    getroute({commit}, data) {
        return new Promise((resolve) => {
            commit('GET_ROUTE', data)
            resolve()


        })

    },

    // user login
    login({commit}, userInfo) {
        const {username, password} = userInfo
        return new Promise((resolve, reject) => {
            login({username: username.trim(), password: password}).then(response => {
                const {data} = response
                commit('SET_TOKEN', data.token)
                let lis = []
                lis = RouteState.state.WhiteRoute.concat(RouteState.state.LoginRoute)
                router.addRoutes(lis)


                resolve(response)
            }).catch((response) => {
                console.log('rrrrrrrrr')


                reject(response)
            })
        })
    },

    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {

            getInfo(state.token).then(response => {
                const data = response.data
                const result = decryption_info(data)
                const userinfo = JSON.parse(window.atob(result))

                if (!userinfo) {
                    return reject('Verification failed, please Login again.')
                }
                commit('SET_INFO', userinfo)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },


    // user logout
    logout({commit}) {
        return new Promise((resolve) => {

            removeToken() // must remove  token  first
            // resetRouter()
            commit('RESET_STATE')
            resolve()

        })
    },


    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}